<script>
import ListActionTemplates from './ListActionTemplates'
import Workflows from './Workflows'
import ActionTemplates from './ActionTemplates'
import ExportImport from './ExportImport'
import FakerInfo from './FakerInfo'
import axios from 'axios'

export default {

  components: {
    ListActionTemplates,
    Workflows,
    ExportImport,
    FakerInfo
  },

  created() {
    if (location.hash && location.hash.substr(0, 10) == '#workflow:') {
      this.workflowImportData = location.hash.substr(10)
      this.activeTab = 3
    }
  },

  data() {
    let index = location.hash.replace('#', '') * 1
    if (!Number.isInteger(index)) {
      index = 0
    }

    return {
      activeTab: index,
      workflowImportData: null,

      migrationsRunning: false
    }
  },

  watch: {
    activeTab() {
      location.hash = this.activeTab
    }
  },

  latestMigration: '2',

  mounted() {
    let latestMigration = localStorage.getItem('latest-migration')
    if (latestMigration != this.$options.latestMigration) {
      this.migrationsRunning = true
      axios.get('/default_data.json').then((response)=>{
        localStorage.setItem('latest-migration', this.$options.latestMigration)
        let json = response.data
        setTimeout(()=>{
          Workflow.storage.replaceAll(json.workflows)
          ActionTemplates.storage.replaceAll(json.action_templates)

          this.migrationsRunning = false
        }, 500)
      })
    }
  }

}
</script>

<template>
  <section>
    <b-modal :active="migrationsRunning" scroll="keep">
      <div class="card">
        <div class="card-content">
          Updating to latest version...
        </div>
      </div>
    </b-modal>

    <b-tabs v-if="!migrationsRunning" v-model="activeTab" :destroy-on-hide="true">

      <b-tab-item label="Workflows" icon="transit-connection-variant">
        <workflows></workflows>
      </b-tab-item>

      <b-tab-item label="Action Templates" icon="network-outline">
        <list-action-templates></list-action-templates>
      </b-tab-item>

      <b-tab-item label="Fake Data" icon="drama-masks">
        <faker-info></faker-info>
      </b-tab-item>

      <b-tab-item label="Export / Import" icon="swap-vertical">
        <export-import :importData.sync="workflowImportData"></export-import>
      </b-tab-item>

    </b-tabs>
  </section>
</template>

<style lang="scss">

</style>